/**
 * academy-promo.js
 *
 * Scroll-into-view reveal for the promotion tiles inside the collection
 * product grid (snippets/product-promotion.liquid): adds `is-inview` to each
 * `[data-promo]` tile once it enters the viewport. CSS handles the actual
 * image / headline (line-mask fade + slide up) animations. Honours
 * prefers-reduced-motion by revealing immediately.
 *
 * Filter behaviour lives in assets/academy-bike-type-filter.js — promo tiles
 * carry `data-biketype-value` and use the exact same FacetFiltersForm engine
 * as the bike-type carousel cards.
 */
(function () {
  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;

  function reveal(el) {
    el.classList.add('is-inview');
  }

  /* Optional per-word "elastic rise" reveal for a promo headline
     (heading_anim: "words" — see snippets/product-promotion.liquid). Each
     word rises out of its own clip window on scroll-in. Progressive
     enhancement: the words are fully visible by default (CSS), so if GSAP
     or ScrollTrigger aren't on the page nothing is hidden. */
  function initWordReveals() {
    var heads = document.querySelectorAll(
      '[data-promo-words]:not([data-promo-words-done])'
    );
    if (!heads.length) return;

    var g = window.gsap;
    var ST = window.ScrollTrigger;

    heads.forEach(function (h) {
      h.setAttribute('data-promo-words-done', '');
    });

    if (reduceMotion || !g || !ST) return;

    heads.forEach(function (head) {
      var inners = head.querySelectorAll('.promo-heading__word-inner');
      if (!inners.length) return;

      var tl = g.timeline({ paused: true });
      tl.fromTo(
        inners,
        { yPercent: 120, rotate: 0.001 },
        {
          yPercent: 0,
          rotate: 0.001,
          ease: 'elastic.out(1, 0.6)',
          duration: 1.4,
          stagger: 0.025
        }
      );

      var played = false;
      var play = function () {
        if (played) return;
        played = true;
        tl.play();
      };

      ST.create({
        trigger: head,
        start: 'top 85%',
        once: true,
        onEnter: play
      });

      // Never leave the words hidden if the trigger somehow doesn't fire
      // (stale measurement before images/fonts load, etc.).
      setTimeout(play, 2600);
    });

    if (typeof ST.refresh === 'function') ST.refresh();
  }

  function initReveal() {
    var tiles = document.querySelectorAll('[data-promo]:not(.is-inview)');
    if (!tiles.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      tiles.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    tiles.forEach(function (t) {
      io.observe(t);
    });
  }

  /* The grid's innerHTML is swapped wholesale on every AJAX facet update
     (FacetFiltersForm.renderProductGridContainer) — watch for it and
     re-scan for freshly inserted promo tiles. */
  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || typeof MutationObserver === 'undefined') return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        initReveal();
        initWordReveals();
      });
    }).observe(grid, { childList: true, subtree: true });
  }

  function init() {
    initReveal();
    initWordReveals();
    watchGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initWordReveals();
    watchGrid();
  });
})();
